import Vue from 'vue'

Vue.component('Modal', 
    () => import('./components/Modal.vue')
)

Vue.component('Loader', 
    () => import('./components/Loader.vue')
)
